import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import { I18nProvider } from "./i18n";
import { SERVICES } from "./content/services";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";

import HomePage from "./pages/HomePage";
import ServicePage from "./pages/ServicePage";
import ContactPage from "./pages/ContactPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPage from "./pages/NotFoundPage";

// Routes are generated from the service registry, so adding or reordering a
// service is a single edit in src/content/services.js.
//
// Note the flat URL shape (/models, not /services/models). Each service page is
// a standalone landing rather than a leaf of a services section.

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />

        {SERVICES.map((service) => (
          <Route
            key={service.slug}
            path={`/${service.slug}`}
            element={<ServicePage slug={service.slug} />}
          />
        ))}

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/legal/terms" element={<LegalPage doc="terms" />} />
        <Route path="/legal/privacy" element={<LegalPage doc="privacy" />} />

        {/* Legacy shape, in case anything ever links to /services/<slug>. */}
        <Route path="/services/:slug" element={<LegacyServiceRedirect />} />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

function LegacyServiceRedirect() {
  const slug = window.location.pathname.split("/").filter(Boolean).pop();
  const known = SERVICES.some((s) => s.slug === slug);
  return <Navigate to={known ? `/${slug}` : "/"} replace />;
}

export default function App() {
  return (
    <I18nProvider>
      <Router>
        <ScrollToTop />
        <AppRoutes />
      </Router>
    </I18nProvider>
  );
}
